import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

import { safeArray } from '@/app/utils/array/safeArray';
import { isApiError } from '@/infra/exceptions/helpers/isApiError';
import { ApiError } from '@/infra/exceptions/instances/ApiError';

import { tryToRefreshToken } from './utils/refresh';

const onResponse = (resp: AxiosResponse) => {
  if (resp.status == 204 && !resp.data) {
    resp.data = [];
  }

  if (resp.config.paginated) {
    return {
      data: safeArray(resp.data.itens),
      totalItems: resp.data.totalItens ?? 0,
    };
  }

  return resp.data;
};

const onResponseError = (client: AxiosInstance) => (error: AxiosError) => {
  const message: string = error.message ?? '';
  const status = error.response?.status ?? 500;

  if (error) {
    if (status === 401) {
      return tryToRefreshToken(client, error.config);
    }
  }

  if (isApiError(error.response?.data)) {
    return Promise.reject(new ApiError(error.response?.data));
  }

  return Promise.reject({ ...error, status, message } as Error);
};

export { onResponse, onResponseError };
